var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66955 13.0479L19.5756 1.13327C19.7449 0.973717 19.9427 0.891828 20.1689 0.887606C20.3951 0.883383 20.5951 0.965716 20.7689 1.1346C20.9427 1.30905 21.0296 1.51038 21.0296 1.7386C21.0296 1.96705 20.9427 2.16527 20.7689 2.33327L8.40055 14.7086C8.19255 14.9164 7.94888 15.0203 7.66955 15.0203C7.39044 15.0203 7.14688 14.9164 6.93888 14.7086L1.20988 8.97927C1.04455 8.81305 0.963217 8.61494 0.965884 8.38494C0.968328 8.15516 1.05688 7.95338 1.23155 7.77961C1.40599 7.61138 1.60599 7.52727 1.83155 7.52727C2.05688 7.52727 2.25644 7.61138 2.43022 7.77961L7.66955 13.0479Z",
    fill: "#00CFA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.47208f43d766546f0a13653d56e30dd0.svg";
export { ForwardRef as ReactComponent };